export const isMembershipServicePerformedByPractitioner = (form, serviceData, clinicId) => {
    if (!serviceData?.service) return false;

    const service = serviceData.service;
    if (!Array.isArray(service.locations) || !service.locations.length) return false;

    const location = service.locations.find(l => l.clinic === clinicId);
    if (!location) return false;

    const staffsPerformingService = location.staffs || [];

    const practitioner = (() => {
        if (form.practitioner) return form.practitioner.id;
        if (form.practitioners?.[0]) return form.practitioners[0].id;
        return null;
    })();

    if (!practitioner) return false;

    return staffsPerformingService.map(({ staff }) => staff).includes(practitioner);
};
